module.exports = __webpack_public_path__ + "img/4.c0ce6cda.svg";